import { Typography } from '@mui/material'

export const CustomInputLabel = ({ label }) => {
  return (
    <Typography variant='subtitle2' component="span" style={{textAlign: 'right', width: '100%', marginBottom: '-10px'}}>
        {label}
    </Typography>
  )
}
